export const CORE_SKILLS_LIMIT = 6;
export const DEVELOPMENTAL_SKILLS_LIMIT = 5;
